<template>
    <div>

        <config-main-title>
            Modelo de Distribuição por Centro de Custo
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Modelo
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum modelo identificado.'" 
                icon="fa-solid fa-percent"
                :action="'Incluir Modelo'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{ dado.id_modelo_distribuicao_centro_custo }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <div v-if="dado.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_modelo_distribuicao_centro_custo ) ? '' : 'Novo' }}
                            Modelo
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_modelo_distribuicao_centro_custo">
                                #{{ item.id_modelo_distribuicao_centro_custo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Nome do Modelo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row" v-if="false">
                            <div class="col col-12">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    placeholder="Todas"
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <az-sub-title title="Centros de Custo" class="mt-3"></az-sub-title>
                        <div v-for="(centro, icx) in item.items" :key="icx">
                            <div class="form-row" v-if="!centro.excluido">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        :edicao="false"
                                        v-model="centro.centro.search">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" @click="centro.excluido = true">
                                                    <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input 
                                        sizing="sm"
                                        icon="fa-solid fa-percent fa-fw"
                                        type="number"
                                        :validate="validate"
                                        v-model="centro.dc_percentual" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        placeholder="Observações..."
                                        v-model="centro.st_observacoes" />
                                </div>
                            </div>
                        </div>
                        
                        <az-input
                            sizing="sm"
                            icon="fa fa-plus fa-fw"
                            type="autocomplete"
                            placeholder="Selecione o Centro de Custo..."
                            service="centro_custos.index"
                            v-model="novo_centro_custo"
                            @input="incluir_centro_custo()">
                        </az-input>

                        <br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="modeloDistribuicaoCentroCusto" :id="item.id_modelo_distribuicao_centro_custo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_modelo_distribuicao_centro_custo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

//import FiltroModel from '../shared/FiltroModel.vue';
//import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            options_classes: [], 
            novo_centro_custo: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,  
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        lista_models_leads: function () { 
            return [
                { id: 'App\\azure\\marcacao', search: 'Faltosos' },
                { id: 'App\\azure\\orcamento', search: 'Orçamentos' },
                { id: 'App\\azure\\requisicao', search: 'Requisição' },
                { id: 'App\\azure\\atendimentoProcedimento', search: 'Retorno Previsto' },
                { id: 'App\\azure\\retornoAtendimento', search: 'Retorno Programado' },
            ];
        }
    },

    methods: { 
        incluir_centro_custo () { 
            if ( !this.novo_centro_custo )
                return; 

            this.item.items.push({
                centro: _.cloneDeep(this.novo_centro_custo),
                dc_percentual: 0, 
                st_observacoes: "", 
                excluido: false, 
            });

            this.novo_centro_custo = null;

            this.$nextTick(() => { 
                this.novo_centro_custo = "";
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_lead_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_modelo_distribuicao_centro_custo: null,
                st_titulo: "", 
                st_observacoes: "", 
                fl_ativo: true,
                items: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'modelo_dists',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            if ( item.id_modelo_distribuicao_centro_custo ) { 

                this.$util.loadItem(this, { 
                    service: 'modelo_dists',
                    func: 'show',
                    parms: { 
                        id: item.id_modelo_distribuicao_centro_custo,
                        cadastro: true, 
                    }
                })
                .then(res => { 
                    this.item = res;
                    $('#edicaoModal').modal('show');
                });

            } else { 

                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');

            }

        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'modelo_dists',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'modelo_dists',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Modelo de Distribuição por Centro de Custo", path: "/cadastros/modelodistcc" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        /*
        this.$util.loadItem(this, {
            service: 'equipamentos',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });
        */

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style scoped>
.modal-dialog-alto {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
